/*
 * newsbot - forked from autobrr
 */

import { DisclosurePanel } from "@headlessui/react";
import { Link } from "@tanstack/react-router";
import {
  ArrowLeftStartOnRectangleIcon,
  Cog6ToothIcon,
  UserCircleIcon,
} from "@heroicons/react/24/outline";
import { useMutation } from "@tanstack/react-query";

import { useAuth } from "@contexts/AuthContext";
import { classNames } from "@utils";
import toast from "@components/hot-toast";
import Toast from "@components/notifications/Toast";
import { NAV_ROUTES } from "./_shared";

export const MobileNav = () => {
  const { user, profile, signOut } = useAuth();

  const logoutMutation = useMutation({
    mutationFn: signOut,
    onSuccess: () => {
      toast.custom((t) => (
        <Toast type="success" body="You have been logged out. Goodbye!" t={t} />
      ));
    },
    onError: (err) => {
      console.error("logout error", err);
      toast.custom((t) => (
        <Toast type="error" body="Failed to log out" t={t} />
      ));
    },
  });

  const displayName = profile?.display_name || user?.email?.split("@")[0] || "User";

  return (
    <DisclosurePanel className="border-b border-gray-300 dark:border-gray-700 sm:hidden">
      {({ close }) => (
        <>
          <div className="px-2 pt-2 pb-3 space-y-1">
            {NAV_ROUTES.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                params={{}}
                onClick={() => close()}
              >
                {({ isActive }) => (
                  <span
                    className={classNames(
                      "shadow-xs border bg-gray-100 border-gray-300 dark:border-gray-700 dark:bg-gray-900 dark:text-white block px-3 py-2 rounded-md text-base",
                      isActive
                        ? "underline underline-offset-2 decoration-2 decoration-sky-500 font-bold text-black"
                        : "font-medium text-gray-600 dark:text-gray-300"
                    )}
                  >
                    {item.name}
                  </span>
                )}
              </Link>
            ))}
          </div>

          {user && (
            <>
              <div className="border-t border-gray-300 dark:border-gray-700" />

              <div className="px-4 py-3">
                <div className="flex items-center gap-2 text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  <UserCircleIcon className="h-5 w-5" aria-hidden="true" />
                  <span>{displayName}</span>
                </div>

                <div className="space-y-1">
                  <Link
                    to="/settings/account"
                    onClick={() => close()}
                    className="flex items-center gap-2 w-full shadow-xs border bg-gray-100 border-gray-300 dark:border-gray-700 dark:bg-gray-900 dark:text-white px-3 py-2 rounded-md text-sm font-medium text-gray-700 dark:text-gray-300"
                  >
                    <UserCircleIcon className="h-4 w-4" aria-hidden="true" />
                    Account
                  </Link>

                  <Link
                    to="/settings"
                    onClick={() => close()}
                    className="flex items-center gap-2 w-full shadow-xs border bg-gray-100 border-gray-300 dark:border-gray-700 dark:bg-gray-900 dark:text-white px-3 py-2 rounded-md text-sm font-medium text-gray-700 dark:text-gray-300"
                  >
                    <Cog6ToothIcon className="h-4 w-4" aria-hidden="true" />
                    Settings
                  </Link>

                  <button
                    onClick={() => logoutMutation.mutate()}
                    disabled={logoutMutation.isPending}
                    className="flex items-center gap-2 w-full shadow-xs border bg-gray-100 border-gray-300 dark:border-gray-700 dark:bg-gray-900 dark:text-white px-3 py-2 rounded-md text-sm font-medium text-gray-700 dark:text-gray-300 disabled:opacity-50"
                  >
                    <ArrowLeftStartOnRectangleIcon className="h-4 w-4" aria-hidden="true" />
                    {logoutMutation.isPending ? "Logging out..." : "Log out"}
                  </button>
                </div>
              </div>
            </>
          )}
        </>
      )}
    </DisclosurePanel>
  );
};
